import { Skeleton } from "@/components/ui";

export function AnalyticsSkeleton() {
  return (
    <main className="mx-auto max-w-7xl p-6">
      <Skeleton className="mb-6 h-8 w-48" />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {[1, 2, 3].map((item) => <Skeleton key={item} className="h-28" />)}
      </div>
      <Skeleton className="mt-6 h-72 w-full" />
      <Skeleton className="mt-4 h-52 w-full" />
    </main>
  );
}
